// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e755eb54","239":"cc57a084","488":"078d499c","732":"bf9dcf5e"}[chunkId] + ".chunk.js";
};